import * as React from 'react';
import { match } from 'ts-pattern';
import { colors } from '@ovpn-ui/styles';
const StatusIndicator = /*#__PURE__*/React.forwardRef(function StatusIndicator({
  size = 'md',
  icon,
  variant,
  ...props
}, ref) {
  if (!variant || !icon) {
    return null;
  }
  const matchedIconColor = match(variant).with('neutral', () => colors.neutralTextBody).with('information', () => colors.informationBase).with('warning', () => colors.warningBase).with('attention', () => colors.attentionBase).with('success', () => colors.successBase).run();
  return /*#__PURE__*/React.cloneElement(icon, {
    ref,
    size,
    style: {
      display: 'inline-block',
      color: matchedIconColor
    },
    ...props
  });
});
export default StatusIndicator;